import { http } from '../utils/http';

export const documentHandler = {
  getLeadDocumentNamesByLeadId: async (leadId) => {
    return await http.get(`/Document/GetLeadDocumentNamesByLeadId?leadId=${leadId}`);
  },
  downloadDocumentFromS3: async (documentId) => {
    return await http.get(`/Document/DownloadDocumentFromS3?documentId=${documentId}`);
  },
  uploadDocumentToS3: async (payload) => {
    return await http.post(
      `/Document/UploadDocumentToS3?LeadId=${payload.leadId}&UserId=${payload.userId}&DocumentType=${payload.documentType}`,
      payload.files
    );
  },
  uploadBulkLeads: async (payload) => {
    return await http.post(
      `/Document/UploadBulkLeads?PipeLineId=${payload.pipeLineId}&UserId=${payload.userId}&DocumentType=${payload.documentType}`,
      payload.files
    );
  },
  uploadBulkLeadsTemp: async (payload) => {
    return await http.post(
      `/Document/UploadDocumentToS3?PipeLineId=${payload.pipeLineId}&UserId=${payload.userId}&DocumentType=${payload.documentType}`,
      payload.files
    );
  },
  deleteDocument: async (fileId) => {
    return await http.post(`/Document/DeleteDocument?documentId=${fileId}`);
  },
};
